import {Controller} from "@hotwired/stimulus"
import {create_embedded_video} from "../init/embedded_video"

class VideoController extends Controller {
  static targets = ["video"]

  connect() {
    const container = this.videoTarget
    this.init_video(container)
  }

  init_video(container) {
    const show_content_tabs = false
    const video = window.gon.video
    const start_time =
      video.can_watch_full_video ? this.get_start_time_from_url() : 0
    video.restricted = false

    create_embedded_video(
      container,
      video,
      show_content_tabs,
      true,
      start_time
    )
  }

  get_start_time_from_url() {
    const url_params = new URLSearchParams(window.location.search)
    return url_params.get("t")
  }
}

export default VideoController
